import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { useSettingShowSideBarV2UI } from "@faire/retailer-visitor-shared/settings/useSettingShowSideBarV2UI";
import { NotificationIconType } from "@faire/retailer-visitor-shared/views/settings/useMenuItems";
import { Button } from "@faire/web--source/slate/Button";
import { Caution } from "@faire/web--source/slate/icons/foundation/Caution";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import React from "react";
import styled from "styled-components";
import { css } from "styled-components";
var NotificationIconRenderer = function(param) {
    var notificationIconType = param.notificationIconType, value = param.value;
    if (notificationIconType === NotificationIconType.CRITICAL) {
        return /*#__PURE__*/ _jsx(PaymentFailure, {
            "data-test-id": "".concat(value, "-notification-critical")
        });
    }
    if (notificationIconType === NotificationIconType.NOTIFICATION) {
        return /*#__PURE__*/ _jsx(NotificationIcon, {
            "data-test-id": "".concat(value, "-notification")
        });
    }
    return null;
};
export var MenuItem = function(param) {
    var menuItem = param.menuItem, isSelected = param.isSelected;
    var showV2UI = useSettingShowSideBarV2UI();
    var path = menuItem.path, value = menuItem.value, handleClick = menuItem.handleClick, handleOnVisible = menuItem.handleOnVisible;
    var menuRef = useDoActionWhenVisible(function() {
        handleOnVisible === null || handleOnVisible === void 0 ? void 0 : handleOnVisible();
    });
    return /*#__PURE__*/ _jsxs(StyledMenuItem, {
        $showV2UI: showV2UI,
        linkTo: path,
        onClick: handleClick,
        buttonRef: menuRef,
        "data-test-id": "side-bar-menu-item-" + value,
        variant: "tertiary",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: isSelected ? "paragraphSansMedium" : "paragraphSansRegular",
                children: menuItem.label
            }),
            /*#__PURE__*/ _jsx(NotificationIconRenderer, {
                notificationIconType: menuItem.notificationIconType,
                value: menuItem.value
            })
        ]
    });
};
var StyledMenuItem = styled(Button).withConfig({
    componentId: "sc-34730858-0"
})([
    "&&&{display:flex;align-items:center;",
    " justify-content:flex-start;text-decoration:none;color:",
    ";&:hover{text-decoration:none;}}"
], function(props) {
    return props.$showV2UI ? css([
        "margin-bottom:",
        ";gap:",
        ";"
    ], getSpacing("1x"), getSpacing("1x")) : css([
        "margin-bottom:",
        ";gap:",
        ";"
    ], getSpacing("4x"), getSpacing("1x"));
}, Core.text.default);
var PaymentFailure = styled(Caution).attrs({
    color: Core.text.critical,
    fontSize: "16px",
    strokeWidth: 1.5
}).withConfig({
    componentId: "sc-34730858-1"
})([
    "position:relative;top:2px;"
]);
var NotificationIcon = styled.div.withConfig({
    componentId: "sc-34730858-2"
})([
    "position:relative;width:8px;height:8px;border-radius:50%;background-color:",
    ";"
], Decorative.shade.orange);
